<template>
    <div class="mcq-box">
        <p>{{ data.content }}</p>
        <div v-for=' (q, idx) in data.questions ' :key=' idx ' class="question" @click=' toggleSelected(idx) '
            :class=' { "selected": myAns[idx], "answer": ( isAnswerChecked && (data.answers.indexOf(idx)>-1) ) }' >
            {{ "("+(1+idx)+") "+ q }}
        </div>
        <p class="mcq-hint" v-show=' isHintShow '>힌트 : {{ data.hint }}</p>
        <p class="mcq-action-box">
            <span class="btn-hint" v-show=' data.hint && !isHintShow && !isAnswerChecked ' @click=' isHintShow = !isHintShow ' >힌트</span>
            <span class="btn-ans" v-show=' !isAnswerChecked ' @click=' checkAnswer '>정답확인</span>
        </p>
        <transition>
            <div class="mcq-check-mark" v-if=' isAnswerChecked '>{{ ansResult }}</div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "sb-mcq",
    props: {
        "data": { type: Object }
        // "quiz": { type: String, default: "문제 내용을 작성하지 않았습니다." },
        // "questions": { type: Array, default: ["문항을 만들지 않았습니다." ]},
        // "answers": { type: Array, default: [0]},
        // "hint": { type: String },
        // "code": { type: String },
        // "commentary": { type: String }
    },
    data() {
        return {
            myAns: [], // 내가 정답 선택 여부 (boolean array)
            isHintShow: false, // 힌트 메세지 보기 여부
            isAnswerChecked: false, // 정답확인을 눌렀는가?
            ansResult: "X" // 정답을 맞췄는가?
        }
    },
    methods: {
        toggleSelected( idx ){ // 정답 선택 토글
            if( this.data.answers.length == 1 ) { // 정답이 1개면 다른거 체크 해제
                for (let i = 0; i < this.myAns.length; i++) {
                   this.myAns[i] = false;
                }
            }
            Window.Vue.set(this.myAns, idx, !this.myAns[idx]);
        },
        checkAnswer(){ // 정답 확인
            // 1. 정답이 하나라도 체크 되었는가?
            let isAnsCheck = false;
            let myChecked = [];
            for(let i=0; i<this.myAns.length; i++) 
                if(this.myAns[i]) {
                    isAnsCheck = true;
                    myChecked.push(i);
                }
            if( !isAnsCheck ){
                alert('정답을 선택해 주세요!');
                return;
            }
            // 모든 정답이 맞는가?
            // console.log(JSON.stringify(this.answers), JSON.stringify(myChecked));
            const isOk = JSON.stringify(this.data.answers) === JSON.stringify(myChecked);
            if(isOk) this.ansResult = "O";

            try {
                var audio = new Audio(`/sound/${ (isOk)?"o":"x" }.mp3`);
                audio.play();
            } catch(e) { console.log(e); }
            this.isAnswerChecked = !this.isAnswerChecked;
        }
    },
    // @lifecycle
    created() {
        // console.log(this.data);
        this.data.answers.sort(function(a, b){return a - b}); // 정답 정렬
        for(let i=0; i<this.data.questions.length; i++)
            this.myAns.push(false); // 초기 체크 여부를 모두 false
    },
    updated(){
        if( this.isAnswerChecked ){
            this.$destroy();
        }
    }
}
</script>

<style>
.mcq-box {
    position: relative;
    border: 1px dotted #ccc;
    padding: 0 20px;
    margin-bottom: 10px; 
}
.mcq-box .mcq-check-mark{
    position: absolute;
    width: 100%;
    left: 0;
    top: calc(50% - 80px);
    text-align: center;
    font-size: 160px;
    font-weight: bold;
    color: red;
}
.mcq-box .ans{
    color: blue;
}
.mcq-box .mcq-hint {
    color: #006666;
}
.mcq-box .question {
    box-sizing: border-box;
    background: #eee;
    border-radius: 5px;
    margin-left: 1%;
    padding: 8px 16px;
    font-size: 1.2em;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 4px; 
}
.mcq-box .question.selected {
    background: #2c3e50;
    color: #eee;
}
.mcq-box .question.answer {
    border: 6px solid #42b983;
}

.mcq-action-box{
    text-align: right;
}
.mcq-box .btn-hint, .mcq-box .btn-ans {
    display: inline-block;
    box-sizing: border-box;
    border-radius: 48px;
    padding: 12px 80px;
    cursor: pointer;
}
.mcq-box .btn-hint {
    background: #eee;
    margin-right: 16px;
}
.mcq-box .btn-ans {
    background: #eee;
}
</style>
